export const LogoLockup = ({ className = "" }) => (
  <span className={`flex items-center gap-2.5 ${className}`}>
    <img src="/images/logo-mark.webp" alt="" width="715" height="532" className="h-9 w-auto sm:h-10" />
    <img src="/images/logo-word.webp" alt="KeepThis!" width="1191" height="220" className="h-6 w-auto sm:h-7" />
  </span>
);
